import { DisabledType, CommunityType, GiftcardType, Country } from '@models/Enums';
import { VendorModel } from '@models/VendorModel';
import { CouponModel } from './CouponModel';
import { GiftcardModel } from './GiftcardModel';
import { CustomerModel } from './CustomerModel';
import { ProductModel } from './ProductModel';
import { EventModel, CashlessModel } from './EventModel';
import { IBenefits } from './Interfaces';
import { ScratchModel } from './ScratchModel';
import { PackageModel } from './PackageModel';
import { LoyaltyPlanModel } from './LoyaltyPlanModel';


export class CommunityModel {
    public constructor(init?: Partial<Pick<CommunityModel, keyof CommunityModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            if (init.loyaltyPlan) {
                init.loyaltyPlan = new LoyaltyPlanModel(init.loyaltyPlan);
            }
            if (init.vendor) {
                init.vendor = new VendorModel(init.vendor);
            }
            if (init.vendors && init.vendors.length) {
                init.vendors = init.vendors.map((item: any) => new CommunityVendorModel(item));
            }
            if (init.giftcards && init.giftcards.length) {
                init.giftcards = init.giftcards.map((item: any) => new GiftcardModel(item));
            }
            if (init.coupons && init.coupons.length) {
                init.coupons = init.coupons.map((item: any) => new CouponModel(item));
            }
            if (init.events && init.events.length) {
                init.events = init.events.map((item: any) => new EventModel(item));
            }
            if (init.cashless && init.cashless.length) {
                init.cashless = init.cashless.map((item: any) => new CashlessModel(item));
            }
            if (init.customers && init.customers.length) {
                init.customers = init.customers.map((item: any) => new CommunityCustomerModel(item));
            }
            if (init.packages && init.packages.length) {
                init.packages = init.packages.map((item: any) => new PackageModel(item));
            }
            if (init.scratches && init.scratches.length) {
                init.scratches = init.scratches.map((item: any) => new ScratchModel(item));
            }
            Object.assign(this, init);
        }
    }
    id: number;
    vendorId: number;

    cmsType: CommunityType;
    appType: CommunityType;

    name: string;
    description: string;
    terms: string;

    thumbnailUrl: string;
    imageUrl: string;

    bannerUrl: string;
    placeHolder: string;
    colorTheme: string;

    isAvailable: boolean;
    showInApp: boolean;

    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    isOwner: boolean = false;
    vendorLoggedId: number;

    vendor: VendorModel;

    vendors: CommunityVendorModel[] = [];

    loyaltyPlan: LoyaltyPlanModel;

    coupons: CouponModel[] = [];
    giftcards: GiftcardModel[] = [];
    products: ProductModel[] = [];
    events: EventModel[] = [];
    cashless: CashlessModel[] = [];
    scratches: ScratchModel[]=[];
    packages: PackageModel[]=[];

    //interface, we filled it into _fillBenefits in community details
    communityBenefits: IBenefits[] = [];

    providers: VendorModel[] = [];

    customers: CommunityCustomerModel[] = [];

    rejectedCustomers: CommunityCustomerModel[] = [];

    forms: CommunityFormModel[] = [];

    country: Country = Country.CR;

    get haveMerch(): boolean {

        let result = false;

        if (this.giftcards.length > 0) {

            this.giftcards.forEach(x => {
                if (x.type == GiftcardType.Merch){
                    result = true;
                    return result;
                }
            });
        }

        return result;
    }

    get havePops(): boolean {

        let result = false;

        if (this.giftcards.length > 0) {

            this.giftcards.forEach(x => {
                if (x.type == GiftcardType.POP){
                    result = true;
                    return result;
                }
            });
        }

        return result;
    }

    get haveDonations(): boolean {

        let result = false;

        if (this.giftcards.length > 0) {

            this.giftcards.forEach(x => {
                if (x.type == GiftcardType.Donation){
                    result = true;
                    return result;
                }
            });
        }

        return result;
    }

    get condition(): string {

        if (this.isOwner) return 'Administrador';

        if (this.vendorLoggedId == this.vendorId) return 'Administrador';

        if (this.vendors?.length > 0) {
            if (this.vendors.some(x => x.vendorId === this.vendorLoggedId && x.approvedAt != null)) return 'Proveedor';
            if (this.vendors.some(x => x.vendorId === this.vendorLoggedId && x.approvedAt == null)) return 'Pendiente';
        }

        if (this.cmsType == CommunityType.Public) return 'Abierta';

        return 'N/A';
    }
}

export class CommunityCustomerModel {

    public constructor(init?: Partial<Pick<CommunityCustomerModel, keyof CommunityCustomerModel>>) {
        if (init) {
            if (typeof init.requestedAt === 'string') {
                init.requestedAt = new Date(init.requestedAt);
            }
            if (typeof init.approvedAt === 'string') {
                init.approvedAt = new Date(init.approvedAt);
            }
            if (typeof init.rejectedAt === 'string') {
                init.rejectedAt = new Date(init.rejectedAt);
            }
            if (typeof init.disabledAt === 'string') {
                init.disabledAt = new Date(init.disabledAt);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            if (init.community) {
                init.community = new CommunityModel(init.community);
            }
            if (init.customer) {
                init.customer = new CustomerModel(init.customer);
            }
            if (init.form) {
                init.form = new CommunityFormModel(init.form);
            }
            if (init.answers && init.answers.length) {
                init.answers = init.answers.map((item: any) => new CommunityFormQuestionModel(item));
            }
            Object.assign(this, init);
        }
    }

    id: number;
    communityId: number;
    customerId: number;
    communityFormId?: number;
    requestCode: string;
    isActive: boolean;
    disabledType: DisabledType;
    disabledAt?: Date;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    requestedAt?: Date;
    approvedAt?: Date;
    rejectedAt?: Date;

    community: CommunityModel;
    customer: CustomerModel;
    form: CommunityFormModel;
    answers: CommunityFormQuestionModel[] = [];
}

export class CommunityFormModel {
	
    public constructor(init?: Partial<Pick<CommunityFormModel, keyof CommunityFormModel>>) {
        if (init) {
            if (typeof init.finishedAt === 'string') {
                init.finishedAt = new Date(init.finishedAt);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            if (init.questions && init.questions.length) {
                init.questions = init.questions.map((item: any) => new CommunityFormQuestionModel(item));
            }
            Object.assign(this, init);
        }
    }

    id: number = 0;
    communityId: number;
    name: string;
    description: string;
    isMainForm = false;
    isAutoApproval: boolean;
    imageUrl: string;
    finishedAt?: Date;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    customersCount: number = 0;
    

    questions: CommunityFormQuestionModel[] = [];

    get isActive(): boolean {

        return this.finishedAt == null ? true : false;
    }
}

export class CommunityFormQuestionModel {

    public constructor(init?: Partial<Pick<CommunityFormQuestionModel, keyof CommunityFormQuestionModel>>) {
        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number = 0;
    communityId: number;
    formId: number;
    question: string;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    get isActive(): boolean {

        return this.deletedAt == null ? true : false;
    }
}

export class CommunityCustomerAnswerModel {

    public constructor(init?: Partial<Pick<CommunityCustomerAnswerModel, keyof CommunityCustomerAnswerModel>>) {
        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number = 0;
    communityId: number;
    customerId: number;
    communityFormId: number;
    communityFormQuestionId: number;
    answer: string;
    createdAt: Date;
    updatedAt?: Date;
}

export class CommunityVendorModel {

    public constructor(init?: Partial<Pick<CommunityVendorModel, keyof CommunityVendorModel>>) {
        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    communityId: number;
    vendorId: number;


    requestCode: string;
    requestedAt: Date;

    approvedAt: Date;

    rejectedAt: Date;


    contactName: string;
    contactPhone: string;
    contactEmail: string;


    isActive: boolean;
    disabledType: DisabledType;
    disabledAt: Date;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    community: CommunityModel;

    vendor: VendorModel;
}